import { defineAction } from '~/prix'
import geoFetchBuildingsAction from './geoFetchBuildings.action.json' with { type: 'json' }
import { z } from 'zod'

const geoFetchBuildingsDefinition = defineAction({
  ...geoFetchBuildingsAction,
  input: z.object({
    municipalityIbgeCode: z.string(),
  }),
  output: z.object({}),
})

export default geoFetchBuildingsDefinition
